///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';

export class GtthLockProjectCommand extends GtthAbstractCommand {
    private showError: boolean;
    private sessionId: string;

    getCommandName(): string {
        return 'GtthLockProjectCommand';
    }

    create(showError: boolean): this {
        this.showError = showError;
        return this;
    }

    doCommand(): void {
        const activity = this.createActivityDTO(false);
        this.sessionId = this.historyService.sessionStorage.getProjectSessionId(this.project.id);
        activity.sessionId = this.sessionId;
        this.sendActivity(activity);
    }

    doCommandActivity(activityDTO: ActivityDTO): void {
        if (activityDTO.sessionId !== this.sessionId) {
            this.historyService.projectStateService.projectLocked(activityDTO.userLogin);
            return;
        }

        if (this.commandResolve) {
            // command sent by this user
            if (activityDTO.successful) {
                this.historyService.projectStateService.projectLocked(activityDTO.userLogin);
                this.historyService.isEditModeEnabled = activityDTO.successful;
                this.historyService.logicalTopology.enableEntitiesListeners();
            }

            this.commandResolve(activityDTO.successful);
        }
    }
}
